module.exports = __webpack_public_path__ + "static/Cover_FAQ_Barn_4_Sve-0f88c1c42d1efd1192e659a9574ca280.svg";